export const contactSyncLocalStorageKey = 'contactSync'
export const driveOauthLocalStorageKey = 'driveOauth'



// WEBPACK FOOTER //
// ./src/features/incrementalCallback/index.js